<template>
    <SrInput
        v-model="internalValue"
        :class="classList"
        v-bind="$attrs"
        :label="label"
        prepend-icon="search"
        @input="emitInput"
        v-on="listeners"
    />
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';
import { SrInput } from '../SrInput';

const ELEMENT_CLASS = 'sr-search-input';

export default {
    name: 'SrSearchInput',
    components: { SrInput },
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: 'Quick search',
        },
        debounceMs: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            internalValue: this.value,
            debounceTimeout: null,
        };
    },
    computed: {
        listeners() {
            // omit input listener to prevent duplicate input listeners
            // eslint-disable-next-line no-unused-vars
            const { input, ...listeners } = this.$listeners;
            return listeners;
        },
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
    },
    methods: {
        emitInput(value) {
            if (!this.debounceMs) {
                this.$emit('input', value);
                return;
            }

            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = setTimeout(() => this.$emit('input', value), this.debounceMs);
        },
    },
};
</script>

<style lang="scss" scoped>
.sr-search-input {
    ::v-deep .v-input__prepend-inner {
        margin-top: 0;
    }
}
</style>
